<div class="consent-container">
  <h2 class="consent-title">
    Patient Consent
  </h2>
  <p class="consent-message">
    {{ CVA_CONSTANTS.MESSAGE.PATIENT_CONSENT }}
  </p>
  <button type="button" class="btn btn-dark consent-button" (click)="consentTaken()">
    Yes, Patient Consents
  </button>
</div>